import type { FilterEvaluator } from './FilterEvaluator';

export class MatchNoneEvaluator<RecordType> implements FilterEvaluator<RecordType> {
  public static readonly INSTANCE: FilterEvaluator<unknown> = new MatchNoneEvaluator<unknown>();

  evaluate(_: RecordType): boolean {
    return false;
  }
}
